import { CommonData } from '../common_schema'

export const snapshotData: CommonData[] = [
  {
    name: 'Storage async snapshot duration',
    mean: 'Avg_async_snapshot_duration:total.values.mean',
    std: 'Avg_async_snapshot_duration:total.values.std',
    location: 'TiKV-Details --> Storage --> Storage async snapshot duration'
  },
  {
    name: 'Local reader reject pct',
    mean: 'Local_reader_reject_pct:total.values.mean',
    std: 'Local_reader_reject_pct:total.values.std',
    location: 'TiKV-Details --> Local reader --> Local reader requests'
  },
  {
    name: 'Number of snapshots(avg between TiKVs)',
    mean: 'number_of_snapshot_avg:total.values.mean',
    std: 'number_of_snapshot_avg:total.values.std',
    location: 'TiKV-Details --> RocksDB KV --> Number of snapshots'
  },
  {
    name: 'Snapshot Actions(summary for all types)',
    mean: 'snapshot_actions:total.values.mean',
    std: 'snapshot_actions:total.values.std',
    location: 'TiKV-Details --> Snapshot --> Snapshot Actions'
  }
]
